import InteractiveCatalogPage from '../../model/interactive/InteractiveCatalogPage';
import CanvasDimension from '../../model/interactive/CanvasDimension';

import InteractiveCatalogPageLayerParser from './InteractiveCatalogPageLayerParser';
import ItemActionParser from './ItemActionParser';

export default class InteractiveCatalogPageParser {

    static parse(node) {
        let interactiveCatalogPage = new InteractiveCatalogPage();

        interactiveCatalogPage.pageId = node.children('ns2\\:pageId').text();
        interactiveCatalogPage.title = node.children('ns2\\:title').text();
        interactiveCatalogPage.description = node.children('ns2\\:description').text();

        interactiveCatalogPage.horizontalIndexImage = node.children('ns2\\:horizontalIndexImage').text();
        interactiveCatalogPage.verticalIndexImage = node.children('ns2\\:verticalIndexImage').text();

        node.children('ns2\\:horizontalLayer').each((i, elem) => {
            interactiveCatalogPage.horizontalLayers.push(InteractiveCatalogPageLayerParser.parse($(elem)));
        });

        node.children('ns2\\:verticalLayer').each((i, elem) => {
            interactiveCatalogPage.verticalLayers.push(InteractiveCatalogPageLayerParser.parse($(elem)));
        });

        node.children('ns2\\:universalLayer').each((i, elem) => {
            interactiveCatalogPage.universalLayers.push(InteractiveCatalogPageLayerParser.parse($(elem)));
        });

        interactiveCatalogPage.horizontalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:horizontalSize'));
        interactiveCatalogPage.verticalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:verticalSize'));
        interactiveCatalogPage.universalSize = InteractiveCatalogPageParser.parseCanvasDimension(node.children('ns2\\:universalSize'));

        node.children('ns2\\:openPageActions').each((i, elem) => {
            interactiveCatalogPage.openPageActions.push(ItemActionParser.parse($(elem)));
        });

        interactiveCatalogPage.horizontalChangePageMode = node.children('ns2\\:horizontalChangePageMode').text();
        interactiveCatalogPage.verticalChangePageMode = node.children('ns2\\:verticalChangePageMode').text();

        interactiveCatalogPage.horizontalPageVerticalScrollPager = false;
        interactiveCatalogPage.verticalPageVerticalScrollPager = false;

        interactiveCatalogPage.backgroundColor = node.children('ns2\\:backgroundColor').text();

        return interactiveCatalogPage;
    }

    static parseCanvasDimension(node) {
        if (node.length > 0) {
            let canvasDimension = new CanvasDimension();
            canvasDimension.width = parseFloat(node.attr('width'));
            canvasDimension.height = parseFloat(node.attr('height'));
            return canvasDimension;
        }
        return undefined;
    }

}
